<template>
  <div class="wrapper view-page px-lg-4">
    <slot name="progress"></slot>
    <div class="background-image"
         :class="{'no-gradient': !gradient,
         'clear': !organization.darkMode}"
         :style="cssProps"></div>
    <TheHeader :show-filters="!noSessions" />
    <section v-if="!noSessions && !showSessionsList"
             class="main notch mt-lg-5" >
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12 col-xl-9 col-xxl-8">
            <LastSession v-if="lastSession"/>
          </div>
        </div>
      </div>
    </section>
    <section class="sessions"
             :class="{'mt-auto' : !showSessionsList }"
             v-if="!noSessions">
      <div class="container-fluid" style="overflow-y: auto;overflow-x: hidden">
        <div class="row">
          <div class="col">
            <h3 class="mb-md-3">{{$t('session.my.sessions')}}</h3>
            <div class="session-filters mb-4">
              <div class="d-flex display-h5 font-weight-light">
                <div class="d-flex display-h5">
                  <div class="pr-3">
                    <div class="p-0 font-weight-light cursor-hand"
                         :class="{'font-weight-bold text-primary': sessionFilter === null}"
                         @click="filterSession(null)">
                      {{$t('session.filter.available')}}
                    </div>
                  </div>
                  <div class="pr-3">
                    <div class="p-0 font-weight-light cursor-hand"
                         :class="{'font-weight-bold text-primary': sessionFilter ===
                          'in_progress'}"
                         @click="filterSession('in_progress')">
                      {{$t('session.filter.started')}}
                    </div>
                  </div>
                  <div class="pl-3 pr-3">
                    <div class="p-0 font-weight-light cursor-hand"
                         :class="{'font-weight-bold text-primary': sessionFilter ===
                          'completed'}"
                         @click="filterSession('completed')">
                      {{$t('session.filter.ended')}}
                    </div>
                  </div>
                  <div class="pl-3">
                    <div class="p-0 font-weight-light cursor-hand"
                         :class="{'font-weight-bold text-primary': sessionFilter ===
                          'expired'}"
                         @click="filterSession('expired')">
                      {{$t('session.filter.expired')}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row sessions-list">
          <div
            v-for="session in (showSessionsList ? sessions : this.sliceByResolution(sessions))"
            :key="session.name"
            class="col-sm-5 col-lg-4 col-xl-4 col-xxl-3">
            <div class="card bg-transparent my-4"
                 :class="{
            'card-locked': !isInferiorToToday(session.start_date)
            || isInferiorToToday(session.due_date)}">
              <div class="d-flex">
                <div class="card-image mr-4">
                  <div class="rounded-circle position-relative w-110px h-110px">
                    <div class="arc"></div>
                    <img class="cover-fit w-111px h-111px rounded-circle"
                         v-if="session.thumbnail_square"
                         :src="getObjectThumbnail('session',
                       organization.id,
                       session.id,
                       session.thumbnail_square)"
                         alt="">
                    <img class="cover-fit w-111px h-111px rounded-circle"
                         v-else
                         src="@/assets/images/no_thumbnail.png"
                         alt="">
                    <ProgressDonut :object="session"
                                   :small="true"
                                   :overlay="true"
                                   :session="true"/>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div class="d-flex display-h7">
                    <div v-if="session.duration > 0" class="pr-2 border-right">
                      {{$t('session.card.duration')}}<br>
                      <span>
                      <b>{{session.duration}}</b> {{$t('session.card.duration.min')}}
                    </span>
                    </div>
                    <div class="pr-2"
                         :class="{ 'pl-2': session.duration > 0,
                             'border-right': session.due_date }">
                      {{$t('session.card.steps')}}<br>
                      <span class="font-weight-bold">
                        {{session.completed_activity}}/{{session.activity_count}}
                      </span>
                    </div>
                    <div class="pl-2" v-if="session.due_date">
                      {{$t('session.card.expire.on')}}<br>
                      <span class="font-weight-bold">{{formatDate(session.due_date)}}</span>
                    </div>
                  </div>
                  <h5 class="card-title font-weight-bold mb-1">
                    {{session.name | str_limit(25)}}</h5>
                  <p class="card-text display-h7 mb-2">
                    {{session.description | str_limit(100)}}</p>
                  <div class="d-flex mb-3">
                    <div v-if="false" class="d-flex align-items-center font-weight-light mr-2" >
                      <inline-svg
                        class="mr-1"
                        width="15" height="15"
                        :src="require('../assets/images/icons/Icon_Topic.svg')"/>
                      <span>
                      {{$t('app.label.forum')}}
                      <span class="font-weight-bold mr-2">3</span>
                    </span>
                    </div>
                    <div v-if="session.badge_count > 0"
                         class="d-flex align-items-center font-weight-light">
                      <inline-svg
                        class="mr-1"
                        width="15" height="15"
                        :src="require('../assets/images/icons/Icon_Badges.svg')"/>
                      <span>
                      {{$t('app.label.badges')}}
                      <span class="font-weight-bold mr-2">
                        {{session.activated_badge}}/{{session.badge_count}}</span>
                    </span>
                    </div>
                    <div v-if="session.has_leaderboard == 1"
                         class="d-flex align-items-center font-weight-light">
                      <inline-svg
                        class="mr-1"
                        width="15" height="15"
                        :src="require('../assets/images/icons/Icon_Leaderboard.svg')"/>
                      <span>
                         {{$t('app.label.leaderboard')}}
                      </span>
                    </div>
                  </div>
                  <template v-if="session.due_date && isInferiorToToday(session.due_date)">
                    <span class="display-h5">{{$t('session.card.expired')}}</span>
                  </template>
                  <template v-else>
                    <template v-if="isInferiorToToday(session.start_date)">
                      <a v-if="session.attendee === null" href="javascript:void(0)"
                         @click="handleSessionClick(session.id)"
                         class="btn  btn-secondary ">
                                                <span>
                          {{$t('app.button.enroll')}}</span>
                      </a>
                      <a v-else href="javascript:void(0)" @click="handleSessionClick(session.id)"
                         class="btn btn-outline-primary">
                        <span v-if="session.completed_activity < 1">
                          {{$t('app.button.start')}}</span>
                        <span v-else-if="session.completed_activity === session.activity_count">
                        </span>
                        <span v-else>{{$t('app.button.continue')}}</span>

                      </a>
                    </template>
                    <template v-else>
                    <span class="display-h5">{{$t('session.card.available.on')}}
                      <span class="font-weight-bold">{{ formatDate(session.start_date) }}</span>
                    </span>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="mt-auto"
             v-if="!noSessions && lastSession">
      <div class="container-fluid">
        <div class="row no-gutters d-xl-flex btn-all-sessions-row">
          <div class="col d-flex">
            <a href="javascript:void(0)" @click="handleAllSessionsClick"
               class="btn btn-primary rounded-top rounded-0 btn-half-up mx-auto mt-auto
               btn-all-sessions animate__animated animate__fadeInRight">
              <inline-svg class="mr-3 rotable"
                          width="15" height="15"
                          :style="[showSessionsList ? {'rotate': '180deg'}:{}]"
                          :src="require('@/assets/images/icons/Icon_DropdownArrow_Down.svg')"/>
              {{showSessionsList ? $t('session.see.last') : $t('session.see.all')}}
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="main h-100 w-100" v-if="noSessions">
      <div class="d-flex h-100 w-100 align-items-center justify-content-around">
      <div class="no-session_text">
        <div class="d-flex justify-content-center align-items-center display-h2">
          <span>{{$t("app.where.is.sessions")}}</span>
        </div>
        <div class="d-flex justify-content-center align-items-center
        display-h5 text-center mt-5 w-100">
          <span>{{ $t("app.no.sessions.available") }}</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center
        display-h5 text-center mt-5 w-100">
          <span>{{ $t("app.invitation.code.title") }}</span>
          <div class=" mt-2 d-flex align-items-center">
            <input type="text"
                   class="form-control"
                   v-model="invitationCode"
                   :placeholder="$t('app.invitation.code.placeholder')">
            <button
              @click="validateCode"
              :disabled="!invitationCode"
              class="ml-3 btn btn-primary">
              <div v-if="formProcessing" class="my-1">
                <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" width="60"
                     viewBox="0 0 60 20" enable-background="new 0 0 0 0" xml:space="preserve">
                    <circle fill="var(--secondary)" stroke="none" cx="6" cy="10" r="6">
                    <animate
                      attributeName="opacity"
                      dur="1s"
                      values="0;1;0"
                      repeatCount="indefinite"
                      begin="0.1"/>
                  </circle>
                  <circle fill="var(--secondary)" stroke="none" cx="26" cy="10" r="6">
                    <animate
                      attributeName="opacity"
                      dur="1s"
                      values="0;1;0"
                      repeatCount="indefinite"
                      begin="0.2"/>
                  </circle>
                  <circle fill="var(--secondary)" stroke="none" cx="46" cy="10" r="6">
                    <animate
                      attributeName="opacity"
                      dur="1s"
                      values="0;1;0"
                      repeatCount="indefinite"
                      begin="0.3"/>
                  </circle>
                </svg>
              </div>
              <div v-else>
                {{$t('app.invitation.code.validate')}}
              </div>
            </button>
          </div>

        </div>
      </div>
      </div>
    </section>
    <transition enter-active-class="animate__animated animate__fadeIn"
                leave-active-class="animate__animated animate__fadeOut">
        <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FETCH_SESSIONS } from '@/store/actions.type';
import HelperMixin from '@/mixins/helperMixin';
import store from '@/store';
import LastSession from '@/views/LastSession.vue';
import TheHeader from '@/views/TheHeader.vue';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

export default {
  name: 'Homepage',
  mixins: [HelperMixin],
  components: {
    TheHeader,
    LastSession,
  },
  data() {
    return {
      noSessions: false,
      showSessionsList: false,
      invitationCode: null,
      formProcessing: false,
    };
  },
  methods: {
    handleAllSessionsClick() {
      this.showSessionsList = !this.showSessionsList;
    },
    sliceByResolution: (sessions) => {
      if (window.innerWidth > 1400) {
        return sessions.slice(0, 4);
      }

      if (window.innerWidth > 1200) {
        return sessions.slice(0, 3);
      }

      return sessions;
    },
    validateCode() {
      this.formProcessing = true;
      this.$router.push({ name: 'invitetosession', params: { code: this.invitationCode } });
    },
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteEnter(to, from, next) {
    store.dispatch(FETCH_SESSIONS).then(() => next(), () => {
      router.push('/');
    });
  },
  beforeMount() {
    this.setOrgCSS();
    this.noSessions = this.sessions.length === 0;

    if (!this.lastSession) {
      this.showSessionsList = true;
    }
  },
  computed: {
    ...mapGetters(['organization', 'sessions', 'lastSession']),
    cssProps() {
      if (!this.showSessionsList && this.lastSession && this.lastSession.thumbnail) {
        return {
          backgroundImage: `url(${this.getObjectThumbnail('session',
            this.organization.id,
            this.lastSession.id,
            this.lastSession.thumbnail)})`,
        };
      }

      if (this.organization.wallpaper) {
        return {
          backgroundImage: `url(${this.getOrganizationWallpaper(
            this.organization.id,
            this.isMobile(),
          )})`,
        };
      }
      return {
        // eslint-disable-next-line global-require
        backgroundImage: `url(${require('@/assets/images/background.jpg')})`,
      };
    },
    gradient() {
      if (!this.showSessionsList && this.lastSession && this.lastSession.thumbnail) {
        return this.lastSession.use_gradient_background;
      }
      if (this.organization.wallpaper) {
        return this.organization.useGradientBackground;
      }
      return true;
    },

  },
};
</script>

<style>
  .no-session_text {
    margin-top: 0 !important;
  }

</style>
